export const CONTINUE = 'ezlo.change_controller.modal.confirm_button.title';
export const DELETE = 'Delete';
export const SAVE = 'Save';
